module.exports = __webpack_public_path__ + "img/microsoft-flight-simulator.e7ae99d4.png";